import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { Grid } from '@mui/material';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import { ChangeControlDataForm } from 'mutation/view-models/registration-beware';
import FiscalCodeValidationList from './fiscal-code-validation-list';

interface ChangeControlDataFormProps {
  changeControlDataForm: ChangeControlDataForm;
  errors: FormikErrors<ChangeControlDataForm> | undefined;
  touched: FormikTouched<ChangeControlDataForm> | undefined;
  handleFormFieldChange: (
    key: keyof ChangeControlDataForm,
    value: ChangeControlDataForm[keyof ChangeControlDataForm]
  ) => void;
}

const ChangeControlDataFormComponent = ({
  changeControlDataForm,
  errors,
  touched,
  handleFormFieldChange,
}: ChangeControlDataFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data rilascio"
          aria-label="Data rilascio"
          value={changeControlDataForm?.effectiveDate || null}
          onChange={(date) => {
            handleFormFieldChange('effectiveDate', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              id="effectiveDate"
              {...params}
              fullWidth
              error={touched?.effectiveDate && Boolean(errors?.effectiveDate)}
              helperText={errors?.effectiveDate}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FiscalCodeValidationList
          label="Validazione codice fiscale"
          value={changeControlDataForm.validationFiscalCode}
          error={touched?.validationFiscalCode && Boolean(errors?.validationFiscalCode)}
          onChange={(event) => handleFormFieldChange('validationFiscalCode', event?.target?.value)}
        />
      </Grid>
    </Grid>
  );
};

ChangeControlDataFormComponent.displayName = 'Change control data form component';

const ChangeControlDataFormMemo = memo(ChangeControlDataFormComponent);
export default ChangeControlDataFormMemo;
